var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"list-item",attrs:{"to":{name: 'RegisterSn'}}},[_vm._v(" "+_vm._s(_vm.$t('sn.register'))+" "),_c('small',[_vm._v(" "+_vm._s(_vm.$t('sn.you_are_eligible'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }